export default __webpack_public_path__ + "static/media/UK.841fc3c5.png";